import { RomEditorState } from 'routes/rom/interfaces';
import { danger, ValidationMapOf } from 'shared/helper-text-helpers';
import { Cabinet } from 'app/components/shared/interfaces';

export function validateCabinet(state: Cabinet): ValidationMapOf<RomEditorState> {
    const ret: ValidationMapOf<RomEditorState> = {};

    try {
        const parsedMetaData = JSON.parse(state.metaData);
        if (typeof parsedMetaData !== 'object' || parsedMetaData === null) {
            ret.metaData = danger('Top-level value must be a JSON object.');
        }
    } catch (e) {
        ret.metaData = danger('Syntax error in JSON');
    }

    return ret;
}
